import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aeecbb36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "payment-requests" }
const _hoisted_2 = { class: "top-up-info" }
const _hoisted_3 = {
  key: 0,
  class: "has-text-centered mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionItem = _resolveComponent("TransactionItem")!
  const _component_FoldableSectionCard = _resolveComponent("FoldableSectionCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.paymentRequestList.length)
      ? (_openBlock(), _createBlock(_component_FoldableSectionCard, {
          key: 0,
          id: "payment-requests-list",
          title: _ctx.$gettext('My unpaid payment requests'),
          count: _ctx.paymentRequestList.length
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$gettext("The following payment requests need to be paid.")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPaymentRequestList, (paymentRequest) => {
              return (_openBlock(), _createBlock(_component_TransactionItem, {
                key: paymentRequest,
                class: "payment-request-item",
                transaction: paymentRequest,
                onClick: ($event: any) => (_ctx.openModal(paymentRequest))
              }, null, 8, ["transaction", "onClick"]))
            }), 128)),
            (_ctx.paymentRequestList.length > 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
            () => {
              _ctx.$modal.open('PaymentRequestListModal', {
                paymentRequestList: _ctx.paymentRequestList,
                account: _ctx.account,
                refreshTransaction: _ctx.refreshTransaction,
                refreshAccounts: _ctx.refreshAccounts,
              })
            }
          ),
                    class: "button custom-button custom-inverted"
                  }, _toDisplayString(_ctx.$gettext("See more")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "count"]))
      : _createCommentVNode("", true)
  ]))
}